var base = require('settings/subscription/cancel-subscription');

import dialogPolyfill from 'dialog-polyfill';

Vue.component('spark-cancel-subscription', {
    mixins: [base],
    data: function(){
        return {
            cancel_modal: null
        };
    },

    methods:{

        /**
         * Confirm the cancellation operation.
         */
         confirmCancellation : function() {
             //$('#modal-confirm-cancellation').modal('show');
             this.cancel_modal = true;
         },

        /**
         * Cancel the current subscription.
         */
        cancel : function() {
            var self = this;
            Spark.delete(this.urlForCancellation, this.form)
                .then(() => {
                    Bus.$emit('updateUser');
                    Bus.$emit('updateTeam');

                    //$('#modal-confirm-cancellation').modal('hide');
                    this.cancel_modal = false;
                });
        }
    }
});
